import { useEffect, useState } from 'react';
import { supabase } from '../supabase';
import { loadLocalVideoTags } from '../demoData';

export interface PlayerVideoTag {
  id: string;
  clip_url: string;
  platform: string | null;
  notes: string | null;
  ts_in: number | null;
  ts_out: number | null;
  corner_id: string | null;
  created_at: string;
}

export function usePlayerVideoTags(playerId: string | undefined, limit = 5, refreshKey: number = 0) {
  const [tags, setTags] = useState<PlayerVideoTag[]>([]);

  useEffect(() => {
    if (!playerId) return;
    void refreshKey;
    let cancelled = false;
    (async () => {
      try {
        const { data, error } = await supabase
          .from('video_tags')
          .select('id, clip_url, platform, notes, ts_in, ts_out, corner_id, created_at')
          .eq('player_id', playerId)
          .order('created_at', { ascending: false })
          .limit(limit);
        if (cancelled) return;
        if (error) { console.warn('[player video tags] load failed', error.message); }
        const rows = (data ?? []) as PlayerVideoTag[];
        if (rows.length > 0) { setTags(rows); return; }
      } catch (err) {
        if (cancelled) return;
        console.warn('[player video tags] threw', err);
      }
      // Fallback: localStorage demo clips
      const local = loadLocalVideoTags()
        .filter((t) => t.player_id === playerId)
        .slice(0, limit);
      setTags(local.map((t) => ({
        id: t.id, clip_url: t.clip_url, platform: t.platform,
        notes: t.notes, ts_in: t.ts_in, ts_out: t.ts_out,
        corner_id: t.corner_id, created_at: t.created_at,
      })));
    })();
    return () => { cancelled = true; };
  }, [playerId, limit, refreshKey]);

  return tags;
}
